import React from "react";

/**
 * English ultrasound waiver — Little Bellies_Waiver Consent Release_04.22.26
 * Numbered items 1–14 match the Word list after the introductory paragraph.
 */
function EnglishWaiverUltrasoundContent() {
  return (
    <div style={{ textAlign: "justify" }}>
      <p>
        <strong>CONSENT AND RELEASE</strong>
      </p>
      <p>
        As a condition of my receiving ultrasound services from Little Bellies
        (also known as Pancitas Franchising LLC and referred to as
        &quot;LB&quot;), I hereby represent, acknowledge, understand and agree
        to the following:
      </p>
      <ol className="px-3">
        <li>
          LB is not a health care provider, and none of its services are intended
          as, or should be considered to be, medical services. None of LB&apos;S
          services are suitable to diagnose, monitor, confirm, or treat any
          medical condition affecting my fetus or me. Although ultrasounds may be
          used by health care providers for clinical purposes, LB&apos;s
          ultrasounds are for purely sentimental, non-clinical purposes.
        </li>
        <li>
          I am under the care of a physician or other health care provider (my
          &quot;Provider&quot;) for my pregnancy. I will not use this ultrasound
          or any LB services as a replacement for, or in lieu of, care and
          treatment given or recommended by my Provider. I will notify my
          Provider of all the services that I have received or intend to receive
          from LB, including but not limited to an ultrasound. I hereby authorize
          LB to give a copy of my ultrasound to my Provider upon request.
        </li>
        <li>
          I have informed LB of any medical conditions, allergies, or other health
          concerns that may affect my sessions with LB. I agree to update LB if my
          health changes.
        </li>
        <li>
          I understand that LB&apos;s services involve physical touch and that I
          may stop or change the session at any time. I will let LB know right
          away if I feel pain, discomfort, or have any concerns.
        </li>
        <li>
          The ultrasound and other services I may receive from LB are generally
          not covered by insurance. Therefore, I will pay for LB&apos;s services
          in advance.
        </li>
        <li>
          The technician who performs the ultrasound is not a doctor, nurse, or
          healthcare provider and cannot interpret or diagnose medical conditions
          from, or prepare clinical reports of, the ultrasound or otherwise offer
          medical advice regarding the images produced.{" "}
          <strong>
            This ultrasound will not be read or interpreted by any physician,
            nurse or other healthcare provider at any time.
          </strong>{" "}
          If and when I share ultrasound images created by LB, I will inform the
          recipient that the ultrasound was prepared solely for sentimental
          purposes and is not suitable for clinical use.
        </li>
        <li>
          This keepsake ultrasound is intended to provide enhanced images for the
          purpose of my viewing fetal movement in utero and is not medically
          inclusive ultrasound or fetal well-being.
        </li>
        <li>
          I will contact my Provider, and not LB, if I have any questions
          concerning this keepsake ultrasound or any other aspect of my
          pregnancy.
        </li>
        <li>
          The quality of the keepsake ultrasound and the DVD, or other audio/visual
          media, depends upon many factors including: body tissue content,
          developmental stage and fetal position. LB does not guarantee the quality
          of the DVD, or other audio/visual media, or the ability to visualize any
          characteristics of the fetus.
        </li>
        <li>
          I understand that publication, presentation or distribution of any
          video taken during the ultrasound session by anyone other than LB, is
          strictly prohibited.
        </li>
        <li>
          I hereby grant LB a lifetime, non-exclusive license to use any and all
          images and video clips taken during my session, or other materials (the
          &quot;Content&quot;) for promotional purposes on all platforms, including
          but not limited to websites, social media (e.g. Facebook, Instagram,
          TikTok, Twitter/X, YouTube) that references or tags LB, whether posted
          by LB or others, without notice or compensation to me.
        </li>
        <li>
          I hereby authorize LB, its affiliates, partners, and service providers
          to communicate with me via telephone, voice message, email, and text
          message for any and all purposes including but not limited to conveying
          the images and videos of my sessions, surveys, promotional offers, and
          other marketing communications.
        </li>
        <li>
          LB&apos;s lack of clinical expertise and factors beyond its control may
          affect the ability to accurately determine the gender of the fetus, and
          LB cannot and does not warrant or guarantee the clarity of the
          ultrasound or accuracy of any gender determination.
        </li>
        <li>
          Although ultrasounds are generally considered safe and do not use
          radiation, I understand that ultrasounds do use high-frequency sound
          waves that can cause very slight temperature increases in tissue
          temperature and accept any and all risks associated with that.
        </li>
      </ol>
      <p>
        <strong>
          IN CONSIDERATION OF THE SERVICES RENDERED, I AGREE TO RELEASE AND HOLD
          HARMLESS LITTLE BELLIES, ITS AGENTS, AFFILIATES, MEMBERS, MANAGERS AND
          EMPLOYEES FROM ANY AND ALL CLAIMS OR CAUSES OF ACTIONS FOR INJURY,
          HARM, DAMAGE, OR OTHER LIABILITY WHICH RESULTS FROM, OR ARE ALLEGED TO
          HAVE RESULTED FROM, THIS KEEPSAKE ULTRASOUND AND ALL OTHER SERVICES
          RENDERED BY LITTLE BELLIES, INCLUDING BUT NOT LIMITED TO, THE FAILURE
          OF A LITTLE BELLIES ULTRASOUND TO ACCURATELY DETERMINE FETAL GENDER OR
          OTHER CHARACTERISTICS OR ANOMOLIES AND ANY DAMAGES OR INJURIES
          RESULTING FROM ULTRASOUND WHICH ARE NOT NOW KNOWN TO OCCUR.
        </strong>
      </p>
      <p>
        I voluntarily choose to receive LB&apos;s services and assume full
        responsibility for my participation. I have carefully read this document
        and by signing at the bottom, acknowledge that I fully understand and
        agree to its contents.
      </p>
    </div>
  );
}

export default EnglishWaiverUltrasoundContent;
